import { useQuery } from "react-query";
import { getRegion } from "../../../../../actions/Utilities/Region";

export default function useRegionOptions() {
  const { data } = useQuery("GetRegionOptions", getRegion, {
    refetchOnWindowFocus: false,
  });
  return data;
}
